import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { formatDateBr } from '@core/utils/filter';
import SLSPicItemService from '@/services/Operacoes/SLSPicItem.service';
// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function usePicItemList(nameModule) {
  // Use toast
  const toast = useToast();
  const sLSPicItemService = new SLSPicItemService();
  const refPicItemListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    // {key: 'DadosItem.item_id', label: 'Item', sortable: true},
    { key: 'DadosItem.familia_comercial.marca.des_marca', label: 'Marca', sortable: true },
    { key: 'DadosItem.item_descricao', label: 'Descrição', sortable: true },
    { key: 'picitemquantidade', label: 'Quantidade disponibilizada', sortable: true },
    { key: 'picitemquantidadesaldo', label: 'Saldo disponível', sortable: true },
    { key: 'picitemvalorpic', label: 'Preço / base R$', sortable: true },
    { key: 'picitemporcentagem', label: 'Desconto %', sortable: true },
    { key: 'picitemfaixas', label: 'Faixas de quantidade', sortable: false },
    { key: 'actions', label: 'Ações', sortable: false },
  ];
  const perPage = ref(5);
  const totalPicItem = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [5, 10, 25, 50, 100];
  const searchQuery = ref('');
  const sortBy = ref('picitemsequencia');
  const statusFilter = ref(null);
  const isSortDirDesc = ref(false);
  const overlay = ref(true);
  const idpic = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refPicItemListTable.value ? refPicItemListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalPicItem.value,
    };
  });

  const refetchData = () => {
    refPicItemListTable.value.refresh();
  };

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    refetchData();
  });

  const fetchPicItem = (ctx, callback = null) => {
    const handleData = (data) => {
      if (typeof callback === 'function') {
        callback(data);
      }
      return data;
    };

    console.log('CHAMEI FETCHPIC', idpic.value);
    return sLSPicItemService.index({
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      idpic: idpic.value,
      fullObject: true,
    }).then((response) => {
      const { data } = response;
      // console.log(data);
      overlay.value = false;
      perPage.value = response.perPage;
      currentPage.value = response.page;
      totalPicItem.value = response.total;

      return handleData(data);
    })
      .catch((error) => {
        console.log(error);
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
        return handleData([]);
      });
  };

  const create = async (body) => {
    body.picid = idpic.value;
    body.picitemquantidadesaldo = body.picitemquantidade;
    const response = await sLSPicItemService.store(body)
      .then((response) => {
        console.log(response);
        toast({
          component: ToastificationContent,
          props: {
            title: 'Sucesso',
            text: 'Itens adicionados com sucesso!',
            icon: 'CheckIcon',
            variant: 'success',
          },
        });
      })
      .catch((error) => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Erro ao adicionar itens. Tente novamente.',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      });
    console.log(response);
    refetchData();
  };
  const Updated = async (body) => {
    await sLSPicItemService.update(body.itemid, body);
    refetchData();
  };

  const removerData = async (body) => {
    await sLSPicItemService.destroy(body);
    refetchData();
  };

  const resolveTypeFieldText = type => {
    if (type === 'VARCHAR') return 'Texto';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'Data';
    if (type === 'DATETIME') return 'Data e Hora';
    if (type === 'DECIMAL') return 'Monetário';
    if (type === 'TEXT') return 'Texto Longo';
    if (type === 'INTEGER' || type === 'INT') return 'Númerico';
    return 'Sem ';
  };
  const resolveTypeFieldIcon = type => {
    if (type === 'VARCHAR') return 'tabler:abc';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'system-uicons:calendar-date';
    if (type === 'DATETIME') return 'formkit:datetime';
    if (type === 'TEXT') return 'mdi:text-long';
    if (type === 'DECIMAL') return 'tabler:decimal';
    if (type === 'DECIMAL' || type === 'INTEGER' || type === 'INT') return 'tabler:123';
    return 'nonicons:type-16';
  };

  const resolveItemStatusVariant = (status) => {
    if (status === 'PENDING') return 'light-warning';
    if (status === 'ATIVO') return 'light-success';
    if (status === 'INATIVO') return 'light-danger';
    return 'primary';
  };

  return {
    fetchPicItem,
    tableColumns,
    perPage,
    currentPage,
    totalPicItem,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    overlay,
    refPicItemListTable,
    statusFilter,
    resolveTypeFieldText,
    resolveTypeFieldIcon,
    resolveItemStatusVariant,
    refetchData,
    create,
    Updated,
    idpic,
    // Extra Filters
    removerData,
  };
}
